import React, { useMemo, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import LoadingAnimation from './LoadingAnimation';

const ErrorIcon = ({ id, hasError = true, errors, loadErrors, intl }) => {
  const [loading, setLoading] = useState(false);
  const tooltip = useMemo(() => {
    if (!errors) return null;

    return (
      <ul>
        {errors.map(error => (
          <li key={error}>{error}</li>
        ))}
      </ul>
    );
  }, [errors, intl]);

  if (!hasError) return null;
  const handleLoading = () => {
    if (typeof loadErrors !== 'function') return;
    setLoading(true);
    return Promise.resolve(loadErrors()).finally(() => {
      setLoading(false);
    });
  };

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="bottom"
      onEntering={handleLoading}
      rootClose
      overlay={<Tooltip id={id}>{loading ? <LoadingAnimation /> : tooltip}</Tooltip>}
    >
      <i className={'fa-fw margin5R fa fa-exclamation-triangle text-danger'} />
    </OverlayTrigger>
  );
};
export default ErrorIcon;
